import { Trash2, Plus } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/Button';
import { useUsers, useDeleteUser } from '@/api/hooks/useUsers';

export function UsersPage() {
  const { data, isLoading } = useUsers();
  const deleteUser = useDeleteUser();

  if (isLoading) {
    return (
      <div
        style={{
          height: 384,
          background: '#e2e8f0',
          borderRadius: 8,
          animation: 'pulse 2s infinite',
        }}
      />
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <h1 style={{ fontSize: 22, fontWeight: 700, margin: 0 }}>Internal Users</h1>
        <Link to="/users/new">
          <Button>
            <Plus size={16} />
            <span>Create User</span>
          </Button>
        </Link>
      </div>

      <div
        style={{
          background: '#fff',
          borderRadius: 8,
          border: '1px solid #e2e8f0',
          overflow: 'hidden',
        }}
      >
        <table>
          <thead style={{ background: '#f8fafc' }}>
            <tr>
              <Th>Email</Th>
              <Th>Role</Th>
              <Th>Teams</Th>
              <Th align="right">Keys</Th>
              <Th align="right">Spend</Th>
              <Th align="right">Actions</Th>
            </tr>
          </thead>
          <tbody>
            {data?.length === 0 ? (
              <tr>
                <td
                  colSpan={6}
                  style={{
                    padding: 32,
                    textAlign: 'center',
                    fontSize: 13,
                    color: '#64748b',
                  }}
                >
                  No users
                </td>
              </tr>
            ) : (
              data?.map((user) => (
                <tr key={user.user_id} style={{ borderTop: '1px solid #e2e8f0' }}>
                  <Td>
                    <Link
                      to={`/users/${encodeURIComponent(user.user_id)}`}
                      style={{ color: '#0f172a', textDecoration: 'none' }}
                    >
                      {user.user_email ?? user.user_id}
                    </Link>
                  </Td>
                  <Td>
                    <span style={{ color: '#64748b' }}>{user.user_role ?? '-'}</span>
                  </Td>
                  <Td>
                    <span style={{ color: '#64748b' }}>
                      {user.teams?.join(', ') ?? '-'}
                    </span>
                  </Td>
                  <Td align="right">
                    {user.key_count != null ? user.key_count : '-'}
                  </Td>
                  <Td align="right">${(user.spend ?? 0).toFixed(2)}</Td>
                  <Td align="right">
                    <Button
                      variant="ghost"
                      size="icon"
                      onClick={() => {
                        if (
                          confirm(
                            `Delete user ${user.user_email ?? user.user_id}?`,
                          )
                        ) {
                          deleteUser.mutate([user.user_id]);
                        }
                      }}
                    >
                      <Trash2 size={16} color="#dc2626" />
                    </Button>
                  </Td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function Th({
  children,
  align,
}: {
  children: React.ReactNode;
  align?: 'left' | 'right' | 'center';
}) {
  return (
    <th
      style={{
        padding: '12px 16px',
        textAlign: align ?? 'left',
        fontSize: 13,
        fontWeight: 500,
        color: '#475569',
      }}
    >
      {children}
    </th>
  );
}

function Td({
  children,
  align,
}: {
  children: React.ReactNode;
  align?: 'left' | 'right' | 'center';
}) {
  return (
    <td
      style={{
        padding: '12px 16px',
        textAlign: align ?? 'left',
        fontSize: 13,
      }}
    >
      {children}
    </td>
  );
}
